import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

type DrawCanvasPreviewProps = {
  $isInitialised: boolean;
};
export const DrawCanvasPreview = styled.div<DrawCanvasPreviewProps>`
  border-radius: ${rem(borderRadius8)};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  overflow: hidden;

  opacity: 0;
  transition: opacity 500ms ease;

  ${({ $isInitialised }) =>
    $isInitialised &&
    `
    opacity: 1;  
  `}
`;
